import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { MdOutlineFileUpload } from "react-icons/md";
import { RxCross1 } from "react-icons/rx";

import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";

interface Props {
    label?: string;
    description?: string;
    placeholder?: string;
    setFile: (file: File | null) => void;
    file: File | null;
}

const FileUploadInput: React.FC<Props> = ({ label, setFile, file, description }) => {
    const onDrop = useCallback(

        (acceptedFiles: File[]) => {
            console.log("Accepted files:", acceptedFiles);
            setFile(acceptedFiles[0]);
        },
        [setFile]
    );

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            "image/*": [], // accepts all image types
            'application/pdf': [], // accepts pdf files
        },
        maxFiles: 1,
        onDrop,
    });

    const handleRemoveFile = () => {
        setFile(null);
    };

    return (
        <div className="flex flex-col gap-2 w-full">
            {label && <Label>{label}</Label>}
            {description && <p className="text-sm text-gray-500">{description}</p>}

            {file === undefined
                || file === null ? (
                <div
                    {...getRootProps()}
                    className="min-h-[150px] border border-dashed border-gray-400 p-4 rounded cursor-pointer items-center justify-center hover:bg-gray-50 transition duration-200"
                >
                    <input {...getInputProps()} />
                    <div className="flex flex-col items-center justify-center gap-2 w-full h-full">
                        <MdOutlineFileUpload size={30} className="text-gray-500" />
                        <p className="text-gray-500 text-sm">
                            Drag & drop a file here, or click to select
                        </p>
                    </div>
                </div>
            ) : (
                <div className="flex items-center justify-between bg-gray-100 p-2 rounded">
                    <p className="text-gray-700 text-sm truncate">{file?.name}</p>
                    <Button
                        variant="outline"
                        size="icon"
                        className="w-6 h-6"
                        type="button"
                        onClick={handleRemoveFile}
                    >
                        <RxCross1 size={14} />
                    </Button>
                </div>

            )}
        </div>
    );
};

export default FileUploadInput;
